import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import WhyUsSection from "./components/WhyUsSection";
import ProductsSection from "./components/ProductsSection";
import BrandsSection from "./components/BrandsSection";
import StatsSection from "./components/StatsSection";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ProductDetailPage from "./components/pages/ProductDetailPage";
import ContactPage from "./components/pages/ContactPage";
import AboutPage from "./components/pages/AboutPage";
import CapabilitiesPage from "./components/pages/CapabilitiesPage";
import SustainabilityPage from "./components/pages/SustainabilityPage";
import ReferencesPage from "./components/pages/ReferencesPage";
import BlogPage from "./components/pages/BlogPage";
import BlogPostPage from "./components/pages/BlogPostPage";
import FAQPage from "./components/pages/FAQPage";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";
import { PageMetadata } from "./components/PageMetadata";
import NotFoundPage from "./components/pages/NotFoundPage";
import { absoluteUrl } from "./utils/routeManifest";

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Etiteks',
  url: absoluteUrl('/'),
  logo: absoluteUrl('/etiteks-logo.png'),
  foundingDate: '1983',
  email: 'info@etiteks.com',
  telephone: '+90 212 501 42 57',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Istanbul',
    addressCountry: 'TR'
  },
  sameAs: [
    'https://www.linkedin.com/company/etitekslabel/',
    'https://www.instagram.com/etitekslabel/',
    'https://wonnda.com/de/lieferanten/etiteks/',
    'https://www.europages.co.uk/en/company/etiteks-22290192'
  ]
};

const Home = () => {
  return (
    <div className="min-h-screen">
      <script type="application/ld+json" data-testid="organization-jsonld">
        {JSON.stringify(organizationSchema).replace(/</g, '\\u003c')}
      </script>
      <Navbar />
      <HeroSection />
      <WhyUsSection />
      <ProductsSection />
      <BrandsSection />
      <StatsSection />
      <Footer />
      <CookieBanner />
    </div>
  );
};

const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', { page_path: location.pathname });
    }
  }, [location]);

  useEffect(() => {
    if (window.location.search.includes('utm_')) {
      setTimeout(() => {
        window.history.replaceState({}, '', window.location.pathname);
      }, 1000);
    }
  }, []);

  return null;
};

function App({ Router = BrowserRouter, routerProps = {} }) {
  return (
    <LanguageProvider>
      <div className="App">
        <Router {...routerProps}>
          <PageMetadata />
          <PageViewTracker />
          <ScrollToTop />
          <WhatsAppButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products/:slug" element={<ProductDetailPage />} />
            <Route path="/capabilities" element={<CapabilitiesPage />} />
            <Route path="/sustainability" element={<SustainabilityPage />} />
            <Route path="/references" element={<ReferencesPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </div>
    </LanguageProvider>
  );
}

export default App;
